"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _elDragDialog = _interopRequireDefault(require("@/directive/el-drag-dialog"));
var _index = _interopRequireDefault(require("@/components/UploadExcel/index.vue"));
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _hike = require("@/api/hike");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import moment from 'moment-timezone'
// import Tinymce from '@/components/Tinymce'
// import QrcodeVue from 'qrcode.vue'
// import { truncate } from '@/filters'
// const defaultValue = []
var _default = exports.default = {
  name: 'HikeAwardSteps',
  components: {
    UploadExcelComponent: _index.default
  },
  directives: {
    elDragDialog: _elDragDialog.default
  },
  data() {
    return {
      dialogVisible: false,
      fullscreenloading: false,
      hike: null,
      myHikeTeams: [],
      myHikeTeamEmails: [],
      isShowResult: false,
      noOfSuccess: 0,
      noOfFail: 0,
      tableData: [],
      tableHeader: [],
      smallDrop: 'smallDrop',
      loading: false
    };
  },
  async created() {
    await this.getHike();
    await this.getHikeParticipantsSteps();
  },
  methods: {
    handleDrag() {
      // this.$refs.select.blur()
    },
    openDialog() {
      this.tableData = [];
      this.tableHeader = [];
      this.isShowResult = false;
      this.dialogVisible = true;
    },
    handleSuccess({
      results,
      header
    }) {
      // console.log('upload excel file-result', results)
      // console.log('upload excel file-header', results)
      this.tableData = _lodash.default.map(results, function (r) {
        return {
          email: _lodash.default.trim(_lodash.default.toLower(r.email)),
          step: _lodash.default.trim(r.step)
        };
      });
      this.tableHeader = header;
    },
    beforeUpload(file) {
      // console.log('upload excel file', file)
      return true;
    },
    doUpload() {
      if (this.tableData.length <= 0) {
        const msg = this.$i18n.t('otrTraining.msgEmptyRecord');
        (0, _log.displayPopupMessage)(msg, 'error');
        return false;
      }
      const hikeId = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      this.fullscreenloading = true;
      this.isShowResult = false;
      this.noOfFail = 0;
      this.noOfSuccess = 0;
      this.updateSteps();
      (0, _ga.writeGaEvent)(this, 'Hike', `${_lifehikesInitData.userEvent.hike.uploadParticipant}`, oEmail, `Hike Id: ${hikeId}`);
    },
    EmailFormatErrorStyle(email) {
      if (email !== '' && !this.myHikeTeamEmails.includes(email)) {
        return 'error';
      }
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return !re.test(email) && email !== '' ? 'error' : '';
    },
    StepFormatErrorStyle(step) {
      const re = /^\d+$/;
      return !re.test(step) && step !== '' ? 'error' : '';
    },
    async updateSteps() {
      for (let i = 0; i < this.tableData.length; i++) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (this.tableData[i].email === '') {
          const msg = 'Please check the email in row ' + (i + 1) + " , it's empty.";
          (0, _log.displayPopupMessage)(msg, 'error');
          this.fullscreenloading = false;
          return;
        }
        if (this.tableData[i].email !== '' && !re.test(this.tableData[i].email)) {
          const msg = 'Please check the email format in row ' + (i + 1);
          (0, _log.displayPopupMessage)(msg, 'error');
          this.fullscreenloading = false;
          return;
        }
        if (!this.myHikeTeamEmails.includes(this.tableData[i].email)) {
          const msg = 'Please check the email in row ' + (i + 1) + " , it's not in participant list.";
          (0, _log.displayPopupMessage)(msg, 'error');
          this.fullscreenloading = false;
          return;
        }
        const reStep = /^\d+$/;
        if (this.tableData[i].step === '' || this.tableData[i].step !== '' && !reStep.test(this.tableData[i].step)) {
          const msg = 'Please check the step in row ' + (i + 1);
          (0, _log.displayPopupMessage)(msg, 'error');
          this.fullscreenloading = false;
          return;
        }
        if (this.tableData[i].step > 999) {
          const msg = 'Please check the step in row ' + (i + 1) + ', max is 999';
          (0, _log.displayPopupMessage)(msg, 'error');
          this.fullscreenloading = false;
          return;
        }
      }
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.isShowResult = true;
      for (let i = 0; i < this.tableData.length; i++) {
        const data = {
          'userUuid': this.myHikeTeams.find(element => element.email === this.tableData[i].email).uuid,
          'step': this.tableData[i].step
        };
        await (0, _hike.updateParticipantStep)(token, this.hike.id, data).then(response => {
          (0, _log.showDebugLog)('registerEnroll-API-OK', response.data);
          this.tableData[i].result = 'Success';
          this.$set(this.tableData, i, this.tableData[i]);
          (0, _log.showDebugLog)('Table content row', i);
          this.noOfSuccess += 1;
        }).catch(error => {
          // showDebugLog('registerEnroll-API-Fail', error.response)
          const msg = typeof error.response === 'undefined' ? error.toString() : error.response.data.message;
          this.noOfFail += 1;
          this.tableData[i].result = 'Fail:' + msg;
          this.$set(this.tableData, i, this.tableData[i]);
          // showDebugLog('registerEnroll-API-Fail', msg)
          (0, _log.showDebugLog)('Table content row', i);
        });
      }
      await this.getHikeParticipantsSteps();
      this.fullscreenloading = false;
    },
    getHike() {
      const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      (0, _hike.getHikeById)(token, id).then(response => {
        this.hike = response.data;
        this.loading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('hike-getHikeById-error', error);
        this.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    async getHikeParticipantsSteps() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      await (0, _hike.getParticipantsSteps)(token, id).then(response => {
        this.myHikeTeams = response.data.rows;
        this.myHikeTeamEmails = response.data.rows.map(row => row.email);
      }).catch(error => {
        (0, _log.showDebugLog)('Hike-getParticipantsSteps-API-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    backToHike() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push(`/hike/edit/${id}`);
    }
  }
};